import React from 'react'
import { useSelector } from 'react-redux'
import { useIntl } from 'react-intl'
import { Box } from '@mui/material'

import { withStyles } from '@mui/styles'

import { useModalContext } from '../../../../ui/modal/contexts'
import { ThemeButton, FilterBox } from '../../../../ui'
import { emailManagementFilterStyles } from './email-management-filter.styles'
import { CreateEmailExceptionDialog } from '../dialog/create-email-exception-dialog.component'
import { EMAIL_MANAGEMENT_FILTERS } from '../../constants/email-management-filters.constants'

export const EmailManagementFilter = withStyles(emailManagementFilterStyles)(() => {
  const intl = useIntl(),
    { formatMessage } = useIntl()
  const {
    actions: { open },
  } = useModalContext()
  const combos = useSelector((state) => state.combos)
  const permissions = useSelector((state) => state.global.permissions)

  const handleCreateEmailException = () =>
    open({
      Component: CreateEmailExceptionDialog,
      type: 'responsive',
      maxWidth: 'md',
      closable: true,
    })

  const filters = EMAIL_MANAGEMENT_FILTERS.map((item, i) => {
    if (item.comboId) {
      item.values = combos[item.comboId] && combos[item.comboId].data
    }
    return {
      ...item,
      label: formatMessage({
        id: 'pages.emailManagement.filters.' + item.name + '.title',
      }),
    }
  })

  return (
    <FilterBox filters={filters}>
      {permissions['gestion_emails'] && (
        <Box ml={2} display="flex" alignItems="center">
          <ThemeButton
            color="primary"
            labelM="sm"
            onClick={handleCreateEmailException}
            sx={{ height: '48px' }}
          >
            {intl.formatMessage({ id: 'pages.emailManagement.addButton.label' })}
          </ThemeButton>
        </Box>
      )}
    </FilterBox>
  )
})
